<template>
  <nav class="bottom-tab xl:hidden">
    <router-link
      v-for="item in items" :key="item.to" :to="item.to"
      class="bottom-tab-item" active-class="active"
    >
      <component :is="item.icon" class="w-5 h-5" />
      <span>{{ item.label }}</span>
    </router-link>
  </nav>
</template>

<script setup>
import { h } from 'vue';

const HomeIcon = () => h('svg', { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', 'stroke-width': 2 }, [
  h('rect', { x: 3, y: 3, width: 7, height: 7, rx: 1 }),
  h('rect', { x: 14, y: 3, width: 7, height: 7, rx: 1 }),
  h('rect', { x: 3, y: 14, width: 7, height: 7, rx: 1 }),
  h('rect', { x: 14, y: 14, width: 7, height: 7, rx: 1 }),
]);
const HoursIcon = () => h('svg', { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', 'stroke-width': 2 }, [
  h('circle', { cx: 12, cy: 12, r: 9 }),
  h('polyline', { points: '12 7 12 12 15 14' }),
]);
const AiIcon = () => h('svg', { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', 'stroke-width': 2.5 }, [
  h('circle', { cx: 12, cy: 12, r: 9 }),
  h('path', { d: 'M9 11a3 3 0 1 1 5.12 2.12L12 15' }),
]);
const CalIcon = () => h('svg', { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', 'stroke-width': 2 }, [
  h('rect', { x: 3, y: 5, width: 18, height: 16, rx: 2 }),
  h('line', { x1: 3, y1: 10, x2: 21, y2: 10 }),
]);
const ProfileIcon = () => h('svg', { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', 'stroke-width': 2 }, [
  h('circle', { cx: 12, cy: 7, r: 4 }),
  h('path', { d: 'M3 21v-2a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4v2' }),
]);

const items = [
  { to: '/', label: 'Accueil', icon: HomeIcon },
  { to: '/heures', label: 'Heures', icon: HoursIcon },
  { to: '/ia', label: 'IA', icon: AiIcon },
  { to: '/calendrier', label: 'Calendrier', icon: CalIcon },
  { to: '/profil', label: 'Profil', icon: ProfileIcon },
];
</script>

<style scoped>
.bottom-tab {
  position: fixed; bottom: 0; left: 0; right: 0; z-index: 40;
  display: flex; justify-content: space-around;
  padding: 8px 4px calc(8px + env(safe-area-inset-bottom));
  background: rgba(5,11,26,.85);
  backdrop-filter: blur(20px); -webkit-backdrop-filter: blur(20px);
  border-top: 1px solid var(--line);
}
.bottom-tab-item {
  display: flex; flex-direction: column; align-items: center; gap: 2px;
  padding: 6px 12px; border-radius: 10px;
  color: var(--muted); font-size: 10px; font-weight: 600;
  transition: color .15s ease;
}
.bottom-tab-item:hover { color: var(--ink); }
.bottom-tab-item.active { color: var(--cyan-light); }
</style>
